import { render, staticRenderFns } from "./MListNews.vue?vue&type=template&id=25391aac&"
import script from "./MListNews.vue?vue&type=script&lang=ts&"
export * from "./MListNews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports